<template>
    <div class="search-container">
        <el-autocomplete ref="autocompleteRef" v-model="searchText"
            :fetch-suggestions="showSuggestions ? querySearch : emptyFetchSuggestions" placeholder="请输入内容"
            value-key="value" :trigger-on-focus="false" @select="handleSelect">
        </el-autocomplete>

        <el-button class="search-btn" :loading="loading" @click="handleSearch">
            按钮
        </el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchText: '三',
            loading: false,
            showSuggestions: false,
            backendData: [],
            userdata:{},
        }
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    methods: {
        // 空函数
        emptyFetchSuggestions(queryString, cb) {
            cb([])
        },

        // 搜索建议函数
        querySearch(queryString, cb) {
            if (!queryString || queryString.trim() === '') {
                cb([])
                return
            }

            if (this.backendData.length > 0) {
                const results = this.backendData.filter(item =>
                    item.value.toLowerCase().includes(queryString.toLowerCase())
                )
                cb(results)
            } else {
                cb([])
            }
        },

        // 点击搜索按钮
        async handleSearch() {
            if (!this.searchText.trim()) {
                this.$message.warning('请输入搜索内容')
                return
            }

            this.loading = true;

            try {
                // 1. 调用后台接口
                const response = await this.callSearchAPI(this.searchText);
                console.log('API响应数据:', response.data);
                this.backendData = this.formatBackendData(response.data.list);
                console.log('格式化后的数据:', this.backendData);
                // 2. 启用建议显示
                this.showSuggestions = true

                // 3. 关键：手动触发下拉框显示
                this.$nextTick(() => {
                    this.triggerDropdown()
                })

            } catch (error) {
                this.$message.error('搜索失败')
                this.showSuggestions = false
            } finally {
                this.loading = false
            }
        },

        // 手动触发下拉框显示（关键方法）
        triggerDropdown() {
            const autocomplete = this.$refs.autocompleteRef
            if (!autocomplete) return

            // 方法1：直接调用组件的内部方法
            if (autocomplete.handleFocus) {
                autocomplete.handleFocus()
            }

            // 方法2：通过DOM操作触发focus
            const input = autocomplete.$el.querySelector('input')
            if (input) {
                // 先blur再focus，确保触发下拉
                input.blur()
                setTimeout(() => {
                    input.focus()
                }, 100)
            }

            // 方法3：强制更新建议列表
            if (autocomplete.suggestions) {
                autocomplete.suggestions = this.backendData
                autocomplete.activated = true
            }
        },

        // 模拟API调用
        async callSearchAPI(keyword) {
            console.log('调用API搜索关键词:', keyword);
            return new Promise((resolve) => { 
                    // this.loading = true;
                    let ajaxurl = this.$api.cyl.enterprise.list() + '?kw=' + keyword;
                    this.$axios
                        .get(ajaxurl, { headers: { AuthToken: this.userdata.token } })
                        .then((res) => { 
                            if (res.data.success) { 
                                resolve(res);
                            } 
                        })
                        .catch((err) => {
                        }); 
            })
        },

        // 格式化数据
        formatBackendData(backendData) {
            if ( backendData) {
                return backendData.map(item => ({
                    value: item.title,
                    id: item.stockCode,
                    rawData: item
                }))
            }
            return []
        },

        handleSelect(item) {
            this.searchText = item.value;
            console.log('选中项数据:', item);
        }
    }
}
</script>

<style scoped>
.search-container {
    display: flex;
    align-items: center;
    width: 400px;
    margin: 20px;
}

:deep(.el-autocomplete) {
    flex: 1;
}

:deep(.el-autocomplete .el-input__inner) {
    border: 1px solid #a0cfff;
    border-radius: 4px;
}

.search-btn {
    background-color: #f56c6c;
    border-color: #f56c6c;
    color: white;
    margin-left: 10px;
    height: 40px;
}
</style>